$('document').ready(function(){
    console.log("5555");
    var getInsta = 0;
    /* Slick Slider For Instagram Feed*/

    /*  Newsletter Pop Up Hide Or Show Condition*/
    /* News Letter  Pop Up Box Form */
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 1000 * 60 * 60 * 24));
        var expires = "expires=" + d.toGMTString();
        window.document.cookie = cname + "=" + cvalue + "; " + expires;
    }
    function getCookie(c_name) {
        if (document.cookie.length > 0) {
            c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = document.cookie.length;
                }
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    }
    function deleteCookie(cname) {
        var d = new Date();
        d.setTime(d.getTime() - (1000 * 60 * 60 * 24));
        var expires = "expires=" + d.toGMTString();
        window.document.cookie = cname + "=" + "; " + expires;
    }
    /* News Letter  Pop Up Box Form Close*/
    var sign_up_news_letter = getCookie("sign_up_news_letter");
    var news_letter_popup_subscribe = getCookie("clientsiteurl-subscribecomplete");
    var news_letter_30days = getCookie("clientsiteurl-subscribe");
    var date_now = new Date().getTime().toString();

    /* Subscribe Pop-Up */
    var Google_captcha = window.location.href.split('/challenge#').pop();

    var success_url = window.location.href.split('?customer_posted=').pop();
    var popup_item = sessionStorage.getItem("popup-box");
    if (Google_captcha == "contact_form") {
       // console.log("14566");
        $("#news-letter").modal("hide");
        // $(".success-message").hide();
    }

    if (popup_item == 'false' && success_url == "true" || success_url == "true#contact_form") {
       // console.log("44");
        $('#news-letter').modal("hide");
        $(".success-message").show();
        window.location.hash = "mc-embedded-subscribe-form";
        $(".subscribe-hide").css("display","none");
    }
    else if (popup_item == 'false') {
        console.log("562");
        $('#news-letter').modal("hide");
        $(".success-message").show();
        // $(".subscribe-hide").css("display","none");
    }

    else if (success_url == "true" || success_url == "true#contact_form") {

        daysToExpire = 2000;

        setCookie("clientsiteurl-subscribecomplete", new Date().getTime() + daysToExpire * 1000 * 60 * 60 * 24, 2000);

        $("#news-letter").modal("show");
        $(".success-message").show();
        //$(".modal-title").hide();
        $(".hide-text").hide();

    }

    if (success_url == "true" && popup_item == "true") {
        $("#news-letter").modal('show');
    }
   else if (news_letter_30days.length > 0 || news_letter_popup_subscribe.length > 0 || Google_captcha == "contact_form" || popup_item == "false") {
        $("#news-letter").modal('hide');
    }else{
        var url = window.location.href;
        var origin = window.location.origin + "/";
        if (origin == url) {
            setTimeout(function () {
                $('#news-letter').modal("show");
            }, 30000)
        } else {
            $('#news-letter').modal("hide");
        }
        $(".success-message").hide();
    }

    /*Newsletter Pop Up Hide Or Show Condition*/

    /*Model Close On Click Event */
    $('#news-letter').on('hide.bs.modal', function () {
        sessionStorage.setItem("model-close", true);
        if (news_letter_30days.length <= 0) {
            daysToExpire = 30;
            setCookie("clientsiteurl-subscribe", new Date().getTime() + daysToExpire * 1000 * 60 * 60 * 24, 2000);
        }
    });
    /*Model Close On Click  Event Close*/
    /* Subscribe Form Onclick Functions */
    var email_name = getCookie('news_email');
    var storedAry = email_name;
    $(document).ready(function () {

        $("button#Subscribe-Model").on("click", function (e) {
            e.preventDefault();
            var email = $("input#newsletter").val().toLowerCase();
            $(".news-letter-footer form#contact_form").attr("id", "newsletter-desktop");
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            var data = regex.test(email);
            var url = window.location.href;
            if (email == "") {
                // $("#error-message").append("enter email");

                $("#email-message_popup").html('<p class="text-danger">Please Enter  Email Address </p>');
                return false;
            } else if (data == false) {
                //$("#error-message").show();
                $("#email-message_popup").html('<p class="text-danger">Please Enter Valid Email Address </p>');
                return false;
            } else {
                if (email_name) {
                    if (storedAry.indexOf(email) > 0) {
                        console.log("45");
                        $("#email-message_popup").html('<p class="text-danger">Email Already Exist </p>');
                        return false;
                    } else {
                        var arr = [email_name, email];
                    }
                } else {
                    var arr = [email];
                }
                var json_str = JSON.stringify(arr);
                setCookie('news_email', json_str, 2000);
                sessionStorage.setItem("popup-box", true);
                $(".newsletter-form").empty();
                $("#contact_form").submit();
                // window.location.href = url +'challenge#contact_form';
            }
        });
        Array.prototype.contains = function (obj) {
            var i = this.length;
            while (i--) {
                if (this[i] == obj) {
                    return true;
                }
            }
            return false;
        }

        // footer newsletter clone code
        $('.site-footer__item-inner--newsletter').addClass('remove').css('display','none')
        var code = $('body').find('.site-footer__item-inner--newsletter').html();
        //$(code).find('.newsletter__submit').attr('id','vivek')
        $('.extra-div').append(code)
        setTimeout(function(){
            $('body .extra-div button.newsletter__submit').attr('id','Subscribe')
        },500)

        $('body .remove').remove();

        $(document).on("click", '#Subscribe', function (e) {
            //$("body button[name='commit']").on("click", function (e) {
            e.preventDefault();
            //console.log("email45");
            $("#news-letter").css("display","none");

            var email = $("input#Email").val().toLowerCase();
           // console.log(email+ "empty");
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            var data = regex.test(email);
            var url = window.location.href;
            if (email == "") {
                $("#email-message").html("<p class='text-danger'>Please Enter Email Address</p>");
                return false;
            } else if (data == false) {
                // $("#error-message-footer").show();
                $("#email-message").html("<p class='text-danger'>Please Enter Valid Email Address </p>");
                return false;
            } else {
                if (email_name) {
                    if (storedAry.indexOf(email) > 0) {
                        $("#email-message").html('<p class="text-danger">Email Already Exist </p>');
                        return false;
                    } else {
                        var arr = [email_name, email];
                    }
                } else {
                    var arr = [email];
                }
                var json_str = JSON.stringify(arr);
                //console.log(json_str);
                setCookie('news_email', json_str, 2000);
                //setCookie('news_email',email,2000);
                sessionStorage.setItem("popup-box", false);
                $("#news-letter").empty();
                $("#ContactFooter").submit();
                // window.location.href = url +'challenge#contact_form';
            }
        });
    });




    /* Subscribe Form Onclick Functions  Close*/
})
